<template>
  <div>
    <!-- We are just showing a spinner here. -->
    <div class="accesslink-loading-status" role="status" aria-live="polite">
      {{ $t('common.loading') }}
    </div>
  </div>
</template>

<script>
import { useAccesslinkStore } from '@/stores/AccesslinkStore';

export default {
  name: "AccesslinkIndex",
  data() {
    return {
      code: "",
    };
  },
  mounted: async function() {
    this.code = this.$route.params.code;

    await this.$recaptchaLoaded('bottomleft');
    this.$recaptchaShowBadge();

    if (this.pod) {
      // In what scenario it is possible for the pod to be present?
      this.$router.replace({ name: 'accesslink:view', params: { pod: this.pod.id } });
      return;
    }

    try {
      const accesslinkStore = useAccesslinkStore();
      const data = await accesslinkStore.refreshAccesslinkInfo(this.code);

      if (data && data.brand && data.brand.color) {
        this.$vuetify.theme.themes.dark.colors.primary = data.brand.color;
        this.$vuetify.theme.themes.light.colors.primary = data.brand.color;

        this.$vuetify.theme.themes.dark.colors['on-list'] = data.brand.color;
        this.$vuetify.theme.themes.light.colors['on-list'] = data.brand.color;
      }

      if (data && data.brand && data.brand.backgroundColor) {
        this.$vuetify.theme.themes.dark.colors.background = data.brand.backgroundColor;
        this.$vuetify.theme.themes.light.colors.background = data.brand.backgroundColor;
      }

      if (data && data.brand && data.brand.foregroundColor) {
        this.$vuetify.theme.themes.dark.colors['tw-surface'] = data.brand.foregroundColor;
        this.$vuetify.theme.themes.light.colors['tw-surface'] = data.brand.foregroundColor;

        this.$vuetify.theme.themes.dark.colors['surface'] = data.brand.foregroundColor;
        this.$vuetify.theme.themes.light.colors['surface'] = data.brand.foregroundColor;
      }

      if (data && data.brand && data.brand.foregroundAccentColor) {
        this.$vuetify.theme.themes.dark.colors['tw-surface-accent'] = data.brand.foregroundAccentColor;
        this.$vuetify.theme.themes.light.colors['tw-surface-accent'] = data.brand.foregroundAccentColor;

        this.$vuetify.theme.themes.dark.colors['list'] = data.brand.foregroundAccentColor;
        this.$vuetify.theme.themes.light.colors['list'] = data.brand.foregroundAccentColor;
      }

      if (data.needPassword) {
        this.$router.replace({ name: 'accesslink:login' });
      } else {
        await accesslinkStore.authorizeAccesslink({
          code: this.code,
        });

        // Load the pod and then redirect to the view page
        await accesslinkStore.refreshAccesslinkContents();
        const accessLinkNodes = data.nodes;
        const accessLinkPods = data.pods;

        if (accessLinkNodes.length === 0 && accessLinkPods.length === 1) {
          this.$router.replace({
            name: 'accesslink:view:pod',
            params: { podid: accessLinkPods[0].id },
          });
        } else if (accessLinkPods.length === 0 && accessLinkNodes.length === 1 && accessLinkNodes[0].pods.length === 1) {
          this.$router.replace({
            name: 'accesslink:view:pod',
            params: { nodeid: accessLinkNodes[0].id, podid: accessLinkNodes[0].pods[0].id },
          });
        } else {
          this.$router.replace({
            name: 'accesslink:view',
          });
        }
      }

    } catch (error) {
      if (error &&
        error.response &&
        error.response.data &&
        error.response.data.error &&
        error.response.data.error.message
      ) {
        // Handled error
        // console.log("ERROR", error.response.data.error.message);
      } else {
        // unhandled error
        console.log(error)
      }
      // Redirect to the login page to show the error
      this.$router.replace({ name: 'accesslink:login' });
    }
  },
  computed: {
    pod: function() {
      const accesslinkStore = useAccesslinkStore();
      const accessLinkPods =  accesslinkStore.getAccesslinkPods;
      return accessLinkPods.length === 1 ? accessLinkPods[0] : null;
    },
  }
}
</script>

<style lang="scss" scoped>
.accesslink-loading-status {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
